import { ASTNode } from 'graphql';
import { visit } from 'graphql/language/visitor';

export const removeDirectives = <T extends ASTNode>(documentNode: T): T =>
  visit(documentNode, {
    Directive: () => null,
  });
